
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "The_height_of_the_uterine_fundus_and_the_length_of_the_uterus_at_different_gestational_weeks",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/The_height_of_the_uterine_fundus_and_the_length_of_the_uterus_at_different_gestational_weeks.vue